import { AppError } from './app-error'

export namespace ForbiddenError {
  export type Data = Record<string, unknown>
}

export class ForbiddenError extends AppError {
  private static NAME: string = 'ForbiddenError'
  public static MESSAGE: string = 'A ação que você está tentando realizar não está autorizada!'

  constructor(
    message?: string | null,
    title?: string | undefined,
    public readonly data?: ForbiddenError.Data
  ) {
    super(ForbiddenError.NAME, message ?? ForbiddenError.MESSAGE, title)
  }
}
